export enum REWARD_CITATION_IMAGES {
  BLOW_BUBBLE_PRAYER = 'blow_bubble_prayer',
  FRONT_OF_PRAYER_SPACE_PRAYER = 'front_of_prayer_space_prayer',
  RAISE_HAND_PRAYER = 'raise_hand_prayer',
  TOGETHER_PRAYER = 'together_prayer',
  SEND_INTENTION_PRAYER = 'send_intention_prayer',
  JESUS_CHRIST = 'jesus_christ',
  VIRGIN_MARY = 'virgin_mary',
}
